import React, { memo, useCallback, useContext, useMemo } from "react";
import { AtendimentoContext } from "../../../contexts/AtendimentoContext";
import { SituacaoAtendimentoContext } from "../../../contexts/SituacaoAtendimentoContext";
import { TipoAtendimentoContext } from "../../../contexts/TipoAtendimentoContext";
import { celularMask } from "../../../components/InputTextMask";
import MultiSelect from "react-multi-select-component";
import { Col, Row } from "react-bootstrap";
import "./index.css";
import caAPI from "../../../services/caAPI";
import ReactTooltip from "react-tooltip";

export const ListaFiltrosCentraisAtendimento = memo(()=>{
  const {listaContatosOrigem, tipoAtendimentoSelecionado, setTipoAtendimentoSelecionado, handleExecutaPesquisaTelaPrincipal, buscandoAtendimentos} = useContext(AtendimentoContext);
  const {situacoesAtendimento} = useContext(SituacaoAtendimentoContext);
  const {tiposAtendimento} = useContext(TipoAtendimentoContext);

  const [situacaoSelecionada, setSituacaoSelecionada] = React.useState([]);
  const [contatoOrigemSelecionado, setContatoOrigemSelecionado] = React.useState([]);

  const isEmail = useCallback((valor)=>{
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor);
  },[])

  const opcoesSituacao = useMemo(()=>{
    return situacoesAtendimento
            .slice()
            .sort((a, b) => a?.nome?.localeCompare(b.nome, 'pt-BR')).map((item) => {
              return {value: item.id, label: item.nome}
            })
  },[situacoesAtendimento]);

  const opcoesTipoAtendimento = useMemo(()=>{
    return tiposAtendimento
            .slice()
            .sort((a, b) => a?.descricao?.localeCompare(b.descricao, 'pt-BR')).map((item) => {
              return {value: item.id, label: item.descricao}
            })
  }, [tiposAtendimento]);

  const opcoesContatoOrigem = useMemo(()=>{
    const valoresUnicos = Array.from(new Set(listaContatosOrigem.map(item => item.valor)));
    return listaContatosOrigem
      .filter(item => valoresUnicos.includes(item.valor))
      .filter((item, idx, arr) => arr.findIndex(i => i.valor === item.valor) === idx)
      .sort((a, b) => a?.descricao?.localeCompare(b.descricao, 'pt-BR'))
      .map((item) => ({
        value: `${item.valor}#${item.ramal}`,
        label: item.descricao ?? (isEmail(item.valor) ? item.valor : celularMask(item.valor))
      }));
  }, [listaContatosOrigem]);

  const handleAplicarFiltro = (dados, chave) => {
    const filtros = JSON.parse(caAPI.getLocalState('filtros'));
    filtros[chave]= dados;
    handleExecutaPesquisaTelaPrincipal(filtros);
  }

  const handleChangeSituacao = (selected) => {
    if(buscandoAtendimentos){
      return;
    }
    setSituacaoSelecionada(selected);
    handleAplicarFiltro(selected, 'situacao');
  }

  const handleChangeTipoAtendimento = (selected) => {
    if(buscandoAtendimentos){
      return;
    }
    setTipoAtendimentoSelecionado(selected);
    handleAplicarFiltro(selected, 'tipo_atendimento');
  }

  const handleChangeContatoOrigem = (selected) => {
    if(buscandoAtendimentos){
      return;
    }
    setContatoOrigemSelecionado(selected);
    handleAplicarFiltro(selected, 'contato_origem_ramal');
  }

  return (
    <Row className="lista-filtros-centrais">
      <ReactTooltip/>
      <Col md={4} sm={12} className="px-1 select-section" data-tip="Status do Atendimento">
        {situacaoSelecionada?.length > 1 && (
          <div className="badge-count-select">{situacaoSelecionada?.length}</div>
        )}
        <MultiSelect
          options={opcoesSituacao}
          labelledBy=""
          disabled={buscandoAtendimentos}
          value={situacaoSelecionada}
          onChange={handleChangeSituacao}
          overrideStrings={{
            selectSomeItems: "Status do Atendimento",
            allItemsAreSelected: "Todos itens selecionados",
            selectAll: "Selecionar todos",
            search: "Pesquisar",
          }}
        />
      </Col>
      <Col md={4} sm={12} className="px-1 select-section" data-tip="Tipo de Atendimento">
        {tipoAtendimentoSelecionado?.length > 1 && (
          <div className="badge-count-select">{tipoAtendimentoSelecionado?.length}</div>
        )}
        <MultiSelect
          options={opcoesTipoAtendimento}
          labelledBy=""
          disabled={buscandoAtendimentos}
          value={tipoAtendimentoSelecionado ?? []}
          onChange={handleChangeTipoAtendimento}
          overrideStrings={{
            selectSomeItems: "Tipo do Atendimento",
            allItemsAreSelected: "Todos itens selecionados",
            selectAll: "Selecionar todos",
            search: "Pesquisar",
          }}
        />
      </Col>
      <Col md={4} sm={12} className="px-1 select-section" data-tip="Ramal">
        {contatoOrigemSelecionado?.length > 1 && (
          <div className="badge-count-select">{contatoOrigemSelecionado?.length}</div>
        )}
        <MultiSelect
          options={opcoesContatoOrigem}
          labelledBy=""
          disabled={buscandoAtendimentos}
          value={contatoOrigemSelecionado}
          onChange={handleChangeContatoOrigem}
          overrideStrings={{
            selectSomeItems: "Ramal",
            allItemsAreSelected: "Todos itens selecionados",
            selectAll: "Selecionar todos",
            search: "Pesquisar",
          }}
        />
      </Col>
    </Row>
  )
})
